module.exports = __webpack_public_path__ + "img/like-icon.6cee426a.png";